module.exports = __webpack_public_path__ + "img/file-circle-exclamation-solid-full.af46e4d3.svg";